export enum WorkerApplicationAcquisitionSource {
  TRABA_APP_WORKER_APPLY = 'TRABA_APP_WORKER_APPLY',
  OPS_DIRECT_CREATE_WORKER_APPLICATION = 'OPS_DIRECT_CREATE_WORKER_APPLICATION',
  VETTING_CAMPAIGN = 'VETTING_CAMPAIGN',
  TRABA_JOB_BOARD_ORGANIC = 'TRABA_JOB_BOARD_ORGANIC',
  TRABA_JOB_BOARD_SPONSORED = 'TRABA_JOB_BOARD_SPONSORED',
  TRABA_JOB_BOARD_FORWARD_FILL = 'TRABA_JOB_BOARD_FORWARD_FILL',
  INDEED_JOB_BOARD_ORGANIC = 'INDEED_JOB_BOARD_ORGANIC',
  INDEED_JOB_BOARD_SPONSORED = 'INDEED_JOB_BOARD_SPONSORED',
  BIZ_INVITE = 'BIZ_INVITE',
  OPS_INVITE = 'OPS_INVITE',
  SHIFT_AUTO_FILL_SYSTEM_INVITE = 'SHIFT_AUTO_FILL_SYSTEM_INVITE',
  DYNAMIC_SHIFT_FILLING_INVITE = 'DYNAMIC_SHIFT_FILLING_INVITE',
  WORKER_WAITLISTED = 'WORKER_WAITLISTED',
  JOBGET = 'JOBGET',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  NEWSLETTER = 'NEWSLETTER',
  WARM_LEADS_CSV_UPLOAD_FROM_INDEED = 'WARM_LEADS_CSV_UPLOAD_FROM_INDEED',
  WARM_LEADS_CSV_UPLOAD_FROM_BUGLE = 'WARM_LEADS_CSV_UPLOAD_FROM_BUGLE',
  WARM_LEADS_CSV_UPLOAD_FROM_ATS = 'WARM_LEADS_CSV_UPLOAD_FROM_ATS',
  WARM_LEADS_CSV_UPLOAD_FROM_OTHER = 'WARM_LEADS_CSV_UPLOAD_FROM_OTHER',
}

export const WORKER_APPLICATION_ACQUISITION_SOURCE_DISPLAY: Record<
  string,
  string
> = {
  [WorkerApplicationAcquisitionSource.TRABA_JOB_BOARD_ORGANIC]:
    'Traba Job Board (Organic)',
  [WorkerApplicationAcquisitionSource.TRABA_JOB_BOARD_SPONSORED]:
    'Traba Job Board (Sponsored)',
  [WorkerApplicationAcquisitionSource.TRABA_APP_WORKER_APPLY]: 'Traba App',
  [WorkerApplicationAcquisitionSource.OPS_DIRECT_CREATE_WORKER_APPLICATION]:
    'Ops Direct Create',
  [WorkerApplicationAcquisitionSource.VETTING_CAMPAIGN]: 'Vetting Campaign',
  [WorkerApplicationAcquisitionSource.TRABA_JOB_BOARD_FORWARD_FILL]:
    'Traba Job Board (Forward Fill)',
  [WorkerApplicationAcquisitionSource.INDEED_JOB_BOARD_ORGANIC]:
    'Indeed (Organic)',
  [WorkerApplicationAcquisitionSource.INDEED_JOB_BOARD_SPONSORED]:
    'Indeed (Sponsored)',
  [WorkerApplicationAcquisitionSource.BIZ_INVITE]: 'Business Invite',
  [WorkerApplicationAcquisitionSource.OPS_INVITE]: 'Ops Invite',
  [WorkerApplicationAcquisitionSource.SHIFT_AUTO_FILL_SYSTEM_INVITE]:
    'Auto Fill System',
  [WorkerApplicationAcquisitionSource.DYNAMIC_SHIFT_FILLING_INVITE]:
    'Dynamic Shift Filling',
  [WorkerApplicationAcquisitionSource.WORKER_WAITLISTED]: 'Worker Waitlisted',
  [WorkerApplicationAcquisitionSource.JOBGET]: 'JobGet',
  [WorkerApplicationAcquisitionSource.FACEBOOK]: 'Facebook',
  [WorkerApplicationAcquisitionSource.GOOGLE]: 'Google',
  [WorkerApplicationAcquisitionSource.NEWSLETTER]: 'Newsletter',
  [WorkerApplicationAcquisitionSource.WARM_LEADS_CSV_UPLOAD_FROM_INDEED]:
    'Warm Leads CSV Upload (Indeed)',
  [WorkerApplicationAcquisitionSource.WARM_LEADS_CSV_UPLOAD_FROM_BUGLE]:
    'Warm Leads CSV Upload (Bugle)',
  [WorkerApplicationAcquisitionSource.WARM_LEADS_CSV_UPLOAD_FROM_ATS]:
    'Warm Leads CSV Upload (Other ATS)',
  [WorkerApplicationAcquisitionSource.WARM_LEADS_CSV_UPLOAD_FROM_OTHER]:
    'Warm Leads CSV Upload (Other)',
}
